module.exports = __webpack_public_path__ + "static/orangina-bc8cceaaadc0834f6448843c8b62d8e0.svg";